module.exports = __webpack_public_path__ + "static/media/468x60_0068_ru.9909f331.jpg";